import { useForm } from 'react-hook-form';

export interface ChangePasswordForm {
  newPassword: string;
  confirmPassword: string;
}

export const useChangePasswordForm = () => {
  const { register, handleSubmit, getValues, formState: { errors } } = useForm<ChangePasswordForm>({
    mode: 'onSubmit',
  });

  const matchValidator = () => {
    const newPassword = getValues('newPassword');
    const confirmPassword = getValues('confirmPassword');

    if (newPassword !== confirmPassword) {
      return 'Las contraseñas no coinciden';
    }

    return true;
  };

  return {
    controls: {
      newPassword: register('newPassword', {
        pattern: {
          value: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)([A-Za-z\d][\!\+\*\-\_\#\.\,]*){8,}$/,
          message: 'La contraseña no cumple los requerimientos mínimos.',
        },
        required: 'Este campo es requerido.',
      }),
      confirmPassword: register('confirmPassword', {
        validate: matchValidator,
        required: 'Este campo es requerido.',
      }),
    },
    errors,
    handleSubmit,
  };
};
